module.exports = __webpack_public_path__ + "img/defactor.26d379b0.png";